import React, { FC } from 'react';

import { Icon } from 'common/components';
import { actionIcCheckCircle24px, navigationIcClose24px } from 'assets/media/icons';

import './MessageBanner.scss';

type MessageBannerProps = {
    message: string;
    onClose?: () => void;
};

const MessageBanner: FC<MessageBannerProps> = ({ message, onClose }: MessageBannerProps) => {
    return (
        <div className="message-banner-container">
            <div className="message-banner-left">
                <Icon src={actionIcCheckCircle24px} className="message-banner-icon" />
                <div
                    className="message-banner-content"
                    dangerouslySetInnerHTML={{ __html: message }}
                />
            </div>
            {onClose && (
                <div className="message-banner-close" onClick={onClose}>
                    <Icon src={navigationIcClose24px}></Icon>
                </div>
            )}
        </div>
    );
};

export default MessageBanner;
